import { BadgeRedoListItem } from "../../../arbiter-components/list/redo-list";
import { RedoRadioGroup } from "../../../arbiter-components/radio/redo-radio-group";
import { RedoTagsDropdownInput } from "../../../arbiter-components/select-dropdown/redo-tags-dropdown-input";
import { LabeledInput, LabelSize } from "../../../labeled-input";
import { Text } from "../../../text";
import {
  ShopifyBasicDiscountCustomerEligibility,
  ShopifySegment,
} from "../../discount-shared";
import { CustomerSearchDropdown } from "../pickers";

export function CustomerEligibilityField({
  eligibility,
  setEligibility,
  selectedCustomerIds,
  setSelectedCustomerIds,
  segmentOptions,
  selectedSegmentOptions,
  onSegmentChange,
}: {
  eligibility: ShopifyBasicDiscountCustomerEligibility;
  setEligibility: (
    eligibility: ShopifyBasicDiscountCustomerEligibility,
  ) => void;
  selectedCustomerIds: string[];
  setSelectedCustomerIds: (customerIds: string[]) => void;
  segmentOptions: BadgeRedoListItem<ShopifySegment>[];
  selectedSegmentOptions: BadgeRedoListItem<ShopifySegment>[];
  onSegmentChange: (items: BadgeRedoListItem<ShopifySegment>[]) => void;
}) {
  return (
    <>
      <LabeledInput
        label={
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            Customer eligibility
          </Text>
        }
        size={LabelSize.EXTRA_SMALL}
      >
        <RedoRadioGroup<ShopifyBasicDiscountCustomerEligibility>
          options={[
            {
              id: ShopifyBasicDiscountCustomerEligibility.All,
              label: "All customers",
            },
            {
              id: ShopifyBasicDiscountCustomerEligibility.Segments,
              label: "Specific customer segments",
            },
            {
              id: ShopifyBasicDiscountCustomerEligibility.Specific,
              label: "Specific customers",
            },
          ]}
          setValue={setEligibility}
          size="xs"
          value={eligibility}
        />
      </LabeledInput>

      {eligibility === ShopifyBasicDiscountCustomerEligibility.Specific && (
        <LabeledInput
          label={
            <Text fontSize="xs" fontWeight="medium" textColor="secondary">
              Select specific customers
            </Text>
          }
          size={LabelSize.EXTRA_SMALL}
        >
          <CustomerSearchDropdown
            selectedCustomerIds={selectedCustomerIds}
            setSelectedCustomerIds={setSelectedCustomerIds}
          />
        </LabeledInput>
      )}

      {eligibility === ShopifyBasicDiscountCustomerEligibility.Segments && (
        <LabeledInput
          label={
            <Text fontSize="xs" fontWeight="medium" textColor="secondary">
              Select customer segments
            </Text>
          }
          size={LabelSize.EXTRA_SMALL}
        >
          <RedoTagsDropdownInput
            options={segmentOptions}
            placeholder="Select customer segments"
            searchPlaceholder="Search segments"
            selectedOptions={selectedSegmentOptions}
            setSelectedOptions={onSegmentChange}
            size="xs"
          />
        </LabeledInput>
      )}
    </>
  );
}
